import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'

export default class PrintRow extends Component {
  static propTypes = {
    date: PropTypes.string,
    weekDay: PropTypes.string,
    project: PropTypes.string,
    task: PropTypes.string,
    nTime: PropTypes.string,
    oTime: PropTypes.string,
    oSegments: PropTypes.array,
    note: PropTypes.string,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { date, weekDay, project, task, nTime, oTime, oSegments, note } = this.props
    return (
      <tr className={styles.printRow}>
        <td style={{ width: '6em' }}>{date.substr(2)}</td>
        <td style={{ width: '3em' }}>{weekDay}</td>
        <td style={{ width: '24em', textAlign: 'left' }}>{project}</td>
        <td style={{ width: '8em' }}>{task}</td>
        <td style={{ width: '3em' }}>{nTime}</td>
        <td style={{ width: '3em', color: 'rgba(255, 82, 119, 0.87)' }}>{oTime}</td>
        <td style={{ width: '8em' }}>
          {oSegments.map((seg, i, arr) =>
            <div key={i}>{
                `${misc.getTimeStr(seg.start)} ~ ${misc.getTimeStr(seg.end)}`
            }</div>
          )}
        </td>
        <td style={{ width: '17em', textAlign: 'left' }}>{note}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/printRow.jsx